import { useSession, type SessionUser } from '@qor/web-shared';
import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';
import { landingPath } from '../routing';

/** [Authorize]: signed out -> /login?return=<this page>. The signed-in user reaches the pages as outlet context. */
export function RequireAuth() {
  const session = useSession();
  const location = useLocation();
  if (session.isPending) return null;
  const user = session.data?.user;
  if (!user) {
    const returnUrl = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?return=${encodeURIComponent(returnUrl)}`} replace />;
  }
  return <Outlet context={user} />;
}

/** The signed-in cardholder, inside RequireAuth. */
export const useUser = () => useOutletContext<SessionUser>();

/** "/": where sign-in would have taken the cardholder, or the sign-in page. */
export function HomeRedirect() {
  const session = useSession();
  if (session.isPending) return null;
  const user = session.data?.user;
  return <Navigate to={user ? landingPath(user) : '/login'} replace />;
}
